import { useOutsideClick } from "hooks";
import { AngleUpIcon } from "assets/svgs";
import { useEffect, useState } from "react";
import { shortenStringByddingDots } from "utils/helpers";
import { userSettingState } from "store/selectors";
import { useAppSelector } from "store/hooks";
import styles from "./styles.module.css";

export function CustomSelect({
  onChange,
  options = [],
  placeholder,
  value,
  classes,
  variant,
  showAbove = false,
}: any) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<any>(null);
  const { isDarkMode } = useAppSelector(userSettingState);
  const ref = useOutsideClick(() => {
    setIsOpen(false);
  });

  useEffect(() => {
    const option = options.find((item: any) => item.label === value);
    setSelectedOption(option);
  }, [value]);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (option: any) => {
    setSelectedOption(option);
    onChange(option?.label);
    setIsOpen(false);
  };

  const title = selectedOption?.label ? { title: selectedOption.label } : {};
  return (
    <div
      className={`${styles.selectMain} ${
        isDarkMode ? styles.darkMode : ""
      } ${classes} ${variant ? styles[variant] : ""}`}
      ref={ref}
    >
      <button
        type="button"
        className={`${styles.selectBtn} ${
          !selectedOption && styles.placeholder
        }`}
        onClick={toggleDropdown}
        {...title}
      >
        {selectedOption
          ? shortenStringByddingDots(selectedOption?.label, 26)
          : placeholder}
        <span className={isOpen ? styles.angleDownIcon : styles.angleUpIcon}>
          <AngleUpIcon />
        </span>
      </button>

      {isOpen && (
        <ul className={`${styles.optionsList} ${showAbove ? "bottom-12" : ""}`}>
          {options.map((option: any) => (
            <li
              key={option.value}
              className={`${styles.option} ${
                selectedOption && selectedOption.value === option.value
                  ? styles.active
                  : ""
              }`}
              onClick={() => handleOptionClick(option)}
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
